import type { DelinquencyReason } from '@ld.consumer-portal/models';

export const DELINQUENCY_REASONS: readonly DelinquencyReason[] = [
  { code: '002', reason: 'delinquencyReason002' },
  { code: '003', reason: 'delinquencyReason003' },
  { code: '004', reason: 'delinquencyReason004' },
  { code: '005', reason: 'delinquencyReason005' },
  { code: '006', reason: 'delinquencyReason006' },
  { code: '007', reason: 'delinquencyReason007' },
  { code: '008', reason: 'delinquencyReason008' },
  { code: '009', reason: 'delinquencyReason009' },
  { code: '010', reason: 'delinquencyReason010' },
  { code: '011', reason: 'delinquencyReason011' },
  { code: '012', reason: 'delinquencyReason012' },
  { code: '013', reason: 'delinquencyReason013' },
  { code: '014', reason: 'commonFieldsIsMilitaryService' },
  { code: '016', reason: 'delinquencyReason016' },
  { code: '017', reason: 'delinquencyReason017' },
  { code: '018', reason: 'delinquencyReason018' },
  { code: '019', reason: 'delinquencyReason019' },
  { code: '020', reason: 'delinquencyReason020' },
  { code: '021', reason: 'delinquencyReason021' },
  { code: '022', reason: 'delinquencyReason022' },
  { code: '023', reason: 'delinquencyReason023' },
  { code: '024', reason: 'delinquencyReason024' },
  { code: '025', reason: 'delinquencyReason025' },
  { code: '026', reason: 'delinquencyReason026' },
  { code: '027', reason: 'delinquencyReason027' },
  { code: '028', reason: 'delinquencyReason028' },
  { code: '029', reason: 'delinquencyReason029' },
  { code: '030', reason: 'delinquencyReason030' },
  { code: '031', reason: 'delinquencyReason031' },
  { code: '032', reason: 'delinquencyReason032' },
  { code: '034', reason: 'delinquencyReason034' },
] as const;
